import React, { ReactNode } from 'react'
import { toast, ToastContentProps, ToastContainer as ToastifyContainer } from 'react-toastify'
import { LuX } from 'react-icons/lu'

import styles from './Toaster.module.css'

const contextClass = {
  success: styles.success,
  error: styles.error,
  default: styles.default,
  warning: styles.warning,
  info: styles.info,
} as const

export interface ToastUIProps {
  message: ReactNode
}
export interface ToasterProps extends ToastUIProps {
  type: keyof typeof contextClass
}

const ToastUI = ({ data, closeToast }: ToastContentProps<ToastUIProps>) => (
  <div className={styles.innerContainer}>
    <span className={styles.message}>{data.message}</span>
    <div className={styles.separator} />
    <button type="button" className={styles.closeButton} onClick={closeToast}>
      <LuX size={24} color={'#FFFFFF'} strokeWidth={1.5} />
    </button>
  </div>
)

export const toaster = ({ type, ...data }: ToasterProps) =>
  toast(ToastUI, {
    type,
    icon: false,
    data,
  })

export const ToastContainer = () => (
  <ToastifyContainer
    position="bottom-center"
    hideProgressBar={true}
    toastClassName={(context) => {
      return [contextClass[context?.type ?? 'default'], styles.container].join(' ')
    }}
    closeButton={false}
    className={styles.toastContainer}
  />
)
